import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordComponent } from './reset-password.component';
import { TokenStorageService } from 'app/reetrak-layout/services/token-storage.service';
import { AuthServiceService } from 'app/services/auth-service.service';
import { LovService } from 'app/reetrak-layout/services/lov.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeSharedModule } from 'app/reetrak-layout/pipe-shared/pipe-shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [ResetPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    PipeSharedModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    TranslateModule,
    // ResetPasswordRoutingModule,
    RouterModule
  ],
  entryComponents: [ResetPasswordComponent],
  providers: [TokenStorageService, AuthServiceService, LovService],
  exports: [RouterModule, ResetPasswordComponent]
})
export class ResetPasswordModule { }
